module.exports = __webpack_public_path__ + "static/media/phone-icon.25109a7b.svg";